import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { ASPECT_RATIO, WIDTH } from "../../molecules/card/Card.style";
const HEIGHT = 72;
const style = () => {
    const { space2, space4, space6, space8 } = theme();
    return StyleSheet.create({
        buttonsContainer: {
            justifyContent: "center",
            marginTop: space4,
            width: "100%",
        },
        cards: {
            aspectRatio: ASPECT_RATIO,
            width: WIDTH,
        },
        container: {
            alignItems: "center",
            flexDirection: "column",
            zIndex: 0,
            width: "100%",
            ...Platform.select({
                web: {
                    transform: [{ translateZ: 0 }],
                },
            }),
        },
        content: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginBottom: space8,
            position: "relative",
            width: "100%",
            zIndex: 10,
        },
        descriptionText: {
            marginBottom: space6,
        },
        finished: {
            position: "absolute",
            width: "100%",
        },
        finishedText: {
            marginHorizontal: space8,
            marginTop: space2,
            textAlign: "center",
        },
        likeDislikeContainer: {
            alignItems: "center",
            flexDirection: "row",
            gap: space6,
            height: HEIGHT,
            justifyContent: "center",
        },
        progress: {
            marginBottom: space4,
            paddingHorizontal: space6,
        },
        success: {
            alignItems: "center",
            aspectRatio: ASPECT_RATIO,
            flexDirection: "column",
            justifyContent: "center",
            position: "absolute",
        },
        successText: {
            textAlign: "center",
        },
    });
};
export { style };
